<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">29. </span>
                    Do the companies you write on behalf of retain at least 25% of the risk?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="companiesRisk25Percent"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.companiesRisk25Percent"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="companiesRisk25Percent"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.companiesRisk25Percent"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('companiesRisk25Percent')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('companiesRisk25Percent') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.companiesRisk25Percent == true || mgaApplication.companiesRisk25Percent === 'true'">
                <label class="orep-label text-danger">If Yes, please explain
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.companiesRisk25Percent == true || mgaApplication.companiesRisk25Percent === 'true'"
                    name="companiesRisk25PercentDetails"
                    v-model="mgaApplication.companiesRisk25PercentDetails"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">30. </span>
                    Do you require and verify that your producers maintain E&O insurance?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="producersMaintainInsurance"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.producersMaintainInsurance"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="producersMaintainInsurance"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.producersMaintainInsurance"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('producersMaintainInsurance')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('producersMaintainInsurance') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.producersMaintainInsurance == true || mgaApplication.producersMaintainInsurance === 'true'">
                <label class="orep-label text-danger">If Yes, please explain
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.producersMaintainInsurance == true || mgaApplication.producersMaintainInsurance === 'true'"
                    name="producersMaintainInsuranceDetails"
                    v-model="mgaApplication.producersMaintainInsuranceDetails"
                >
              </div>
            </article>


            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">   CLAIMS & REGULATORY  </h1>
            </article>

            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">1. </span>
                    Have you or any employee of yours been subject to disciplinary action by any State or Federal Agency or Insurance Department?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="subjectToDisciplinaryAction"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.subjectToDisciplinaryAction"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="subjectToDisciplinaryAction"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.subjectToDisciplinaryAction"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('subjectToDisciplinaryAction')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('subjectToDisciplinaryAction') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.subjectToDisciplinaryAction == true || mgaApplication.subjectToDisciplinaryAction === 'true'">
                <label class="orep-label text-danger">If Yes, please explain
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.subjectToDisciplinaryAction == true || mgaApplication.subjectToDisciplinaryAction === 'true'"
                    name="subjectToDisciplinaryActionDetails"
                    v-model="mgaApplication.subjectToDisciplinaryActionDetails"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">2. </span>
                    During the last five years have any claims or suits been made against the applicant or any of its predecessors in business, or any of the past or present directors, officers, solicitors, or employees?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="claimsAgainstApplicantLast5Years"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.claimsAgainstApplicantLast5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="claimsAgainstApplicantLast5Years"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.claimsAgainstApplicantLast5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('claimsAgainstApplicantLast5Years')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('claimsAgainstApplicantLast5Years') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.claimsAgainstApplicantLast5Years == true || mgaApplication.claimsAgainstApplicantLast5Years === 'true'">
                <label class="orep-label text-danger">If Yes, please explain
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.claimsAgainstApplicantLast5Years == true || mgaApplication.claimsAgainstApplicantLast5Years === 'true'"
                    name="claimsAgainstApplicantLast5YearsDetails"
                    v-model="mgaApplication.claimsAgainstApplicantLast5YearsDetails"
                >
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">3. </span>
                    Are you, after inquiry of each person proposed for insurance, aware of any circumstance, error, omission, or offense that may result in a claim being made against the applicant or any of the applicant's employees?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="claimsAgainstApplicantAfterInquiry"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.claimsAgainstApplicantAfterInquiry"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="claimsAgainstApplicantAfterInquiry"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.claimsAgainstApplicantAfterInquiry"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('claimsAgainstApplicantAfterInquiry')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('claimsAgainstApplicantAfterInquiry') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.claimsAgainstApplicantAfterInquiry == true || mgaApplication.claimsAgainstApplicantAfterInquiry === 'true'">
                <label class="orep-label text-danger">If Yes, please explain
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.claimsAgainstApplicantAfterInquiry == true || mgaApplication.claimsAgainstApplicantAfterInquiry === 'true'"
                    name="claimsAgainstApplicantAfterInquiryDetails"
                    v-model="mgaApplication.claimsAgainstApplicantAfterInquiryDetails"
                >
              </div>
            </article>

            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">  COVERAGE REQUESTED </h1>
            </article>
            <article class="input-section form-section">
              <div class="row mb-3">
                <div class="col-md-8">
                  <label for class="orep-label mb-0 ml-1">
                    if your application for insurance is accepted what is the requested effective date?
                  </label>
                </div>
                <div class="col-md-4">
                  <datepicker
                      name="effectiveDate"
                      v-model="mgaApplication.effectiveDate"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input-date"
                      @input="validateBeforeSubmit()"
                      v-validate="'required'"
                      :clearButton="false"
                      :value="computedDates"
                  ></datepicker>
                  <span
                      v-show="errors.has('effectiveDate')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('effectiveDate') | filterText }}</span>
                </div>

              </div>

              <label for class="orep-label">
                Each and Every claim and in the Aggregate?
              </label>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-three"
                      value="2M"
                      class="orep-radio"
                      :checked="mgaApplication.desiredCoverage.find(coverage => coverage === '2M')"
                      v-validate="'required|included:2M,1M,0.5M,0.3M,other'"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$2,000,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-three"
                      value="1M"
                      class="orep-radio"
                      :checked="mgaApplication.desiredCoverage.find(coverage => coverage === '1M')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$1,000,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-two"
                      value="0.5M"
                      class="orep-radio"
                      :checked="mgaApplication.desiredCoverage.find(coverage => coverage === '0.5M')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$500,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-four"
                      value="0.3M"
                      class="orep-radio"
                      :checked="mgaApplication.desiredCoverage.find(coverage => coverage === '0.3M')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$300,000</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="desiredCoverage"
                      id="claim-other"
                      value="other"
                      class="orep-radio"
                      :checked="mgaApplication.desiredCoverage.find(coverage => coverage === 'other')"
                      @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">other</span>
                </label>
              </div>
              <span
                  v-show="errors.has('desiredCoverage')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('desiredCoverage') | filterText }}</span>
              <input
                  type="text"
                  class="orep-text-input"
                  name="desiredCoverageCustomLimit"
                  placeholder="Request a different Limit:"
                  v-if="mgaApplication.desiredCoverage.find(coverage => coverage === 'other')"
                  v-model="mgaApplication.desiredCoverageCustomLimit"
              >
              <div class="row mb-3">
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <label for class="orep-label">
                    What deductible are you requesting?
                  </label>
                  <div class="d-flex flex-row align-items-center row px-3">
                    <label class="orep-label col-md-3 mb-0">
                      <span class="mr-2"></span>
                      Select Deductible:
                    </label>
                    <select
                        class="orep-select col-md-3 w-100"
                        name="deductible"
                        v-model="mgaApplication.deductible"
                        v-validate="'required'"
                    >
                      <option value="5000">$5000</option>
                      <option value="10000">$10,000</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <span
                      v-show="errors.has('deductible')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('deductible') | filterText }}</span>
                </div>
              </div>

              <div v-if="mgaApplication.deductible === 'other'" class="row mb-3">
                <div class="col-md-8">
                  <input
                      type="text"
                      class="orep-text-input"
                      name="deductibleCustomLimit"
                      placeholder="Other Deductible:"
                      v-if="mgaApplication.deductible === 'other'"
                      v-model="mgaApplication.deductibleCustomLimit"
                      @input="validateBeforeSubmit()" />
                </div>
              </div>

            </article>

          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ibdpro-mga-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button class="pagination-dots" @click="navigateToOne()"></button>
            <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-2')"></button>
            <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-3')" :disabled="!state.pageThreeIsValid"></button>
            <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-4')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
            <span class="pagination-dots pagination-current"></span>
            <button class="pagination-dots" @click="navigateToNext('ibdpro-mga-application-6')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid"></button>
            <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-7')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageFourIsValid"
            :class="{submitDisabled: !state.pageFourIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ibdpro-mga-application-6')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";

var moment = require('moment')
export default {
  name: "ibdpro-mga-application-4",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.mgaApplication.desiredCoverage.find(coverage => coverage === event.target.value)) {
        if (this.mgaApplication.desiredCoverage.length < 1) {
          this.mgaApplication.desiredCoverage.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 coverages.'
          });
          event.target.checked = false
        }
      } else {
        this.mgaApplication.desiredCoverage = this.mgaApplication.desiredCoverage.filter(coverage => coverage !== event.target.value);
      }
    },
    navigateToOne() {
      this.$router.push({
        name: "ibdpro-mga-application-1"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    }
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td, table th {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
